interface WithName {
  name: string;
}

export default function sortByName(a: WithName, b: WithName): number {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
}
